import { Component, OnInit } from '@angular/core';
import { ConversationService } from '../../../service/component_dependent/messages/conversation.service';
import { Data } from '../../../model/data';
import { StorageService } from '../../../service/managers/storage.service';
import { ContactsService } from '../../../service/component_dependent/contacts/contacts.service';
import { MessagesService } from '../../../service/component_dependent/messages/messages.service';
import { Router, ActivatedRoute } from '@angular/router';
import { JsonManager } from '../../../service/managers/json-manager';
import { Conversations } from '../../../model/conversations';
import { Contacts } from '../../../model/contacts';
import { CustomQueryService } from '../../../service/managers/custom-query.service';
import { ContactNumber } from '../../../model/contact-number';
import { NotifierService } from '../../../service/component_dependent/notifier.service';
import { optimizeGroupPlayer } from '@angular/animations/browser/src/render/shared';

@Component({
  selector: 'app-messages-all',
  templateUrl: './messages-all.component.html',
  styleUrls: ['./messages-all.component.scss']
})
export class MessagesAllComponent implements OnInit {

  protected data: Data[];
  private arrCVID = [];

  protected loading: boolean = false;

  protected keyword: string;
  private readonly URL_ALL: string = "all";
  private readonly URL_UNREAD: string = "unread";
  private readonly URL_SENT: string = "sent";

  protected page: number = 1;
  protected total: number;
  protected maxItemPerPage: number = 10;


  enableHoverCursorPointer: boolean;
  enableEdit: boolean;

  selUser:number = 0;
 

  constructor(private conversationService: ConversationService,
    private storageService: StorageService,
    private contactService: ContactsService,
    private messageService: MessagesService,
    private customQueryService: CustomQueryService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private notifierService: NotifierService) {

      this.enableEdit = true;
      this.enableHoverCursorPointer = true;

    this.activatedRoute.url.subscribe(
      (data: any) => {
        console.log('All Messages Navigation:' + JSON.stringify(data[0].path))
        this.initComponents(data[0].path,data);
      }
    );
  }

  ngOnInit() {
    this.activatedRoute.params.subscribe(
      (data: any) => {
         console.log('User ID:' + data.id)

         console.log('Query String:' + JSON.stringify(data))
         this.selUser = data.id
      }
    )
  }

  protected onEdit(data: any) {
    this.storageService.setContactSelected(data);
    this.conversationService.setConversationRead(data.cv_id).subscribe(
      (dataConversation: any) => {
         
      },
      (errConversations: any) => {
        this.notifierService.showError(JsonManager.getBreakLineSeparatedErrorMessages(errConversations.error));
      }
    );
    
    this.router.navigateByUrl("/joytogive/messages/conversation/" + data.cv_id);
  }

  protected getConversations(page, keyword, maxItemPerPage) {
    this.page = page;
    this.keyword = keyword;
    this.maxItemPerPage = maxItemPerPage;
    
    this.activatedRoute.url.subscribe(
      (data: any) => {
        console.log('Activited Route Message Al:' + JSON.stringify(data[0].path))
        this.initComponents(data[0].path,data);
      }
    );
  }

  private initComponents(url: string, dtp: any) {
    console.log('Init Components:')
    let userID: number;
    let reqObj;

    this.loading = true;
    this.data = new Array<Data>();

    userID = this.storageService.getUser().id;

    if(dtp.length > 0){
     
      if(dtp.length > 1){
        userID = dtp[1]['path']
      }

      const opt = {
         userID: userID,
         filterType: url
      }

      this.conversationService.$staffid.next(opt);
    }
    //console.log('User ID before load conversations:' + userID + ' THE SELETED:' + this.selUser)

    
    reqObj = {
      "user_id": userID,
      'maxItemPerPage': this.maxItemPerPage,
      'keyword': this.keyword,
      'page': this.page,
      'filter_type': url
    }

    this.conversationService.getConversations(reqObj).subscribe(
      (dataConv: any) => {
        this.data = dataConv.data;
        this.total = dataConv.total;
      },
      (errorConv: any) => {
         console.log("Error Conversation Service:" + JSON.stringify(errorConv))
      },
      () => {
        this.loading = false;
      }
    )

    //this.loading = false;
  }

  // private async getAllMessages(arr: any) {

  //   let instance: Data;

  //   await this.customQueryService.getContactsAndRecentMessage(arr).toPromise().then(
  //     (dataCustom: any) => {

  //       let obj;

  //       obj = dataCustom.data;

  //       for (let i = 0; i < obj.length; i++) {
  //         instance = new Data();
  //         instance.id = obj[i].cv_id;
  //         instance.contact = new Contacts();
  //         instance.conversation = new Conversations();
  //         instance.contact_number = new ContactNumber();
  //         instance.contact_number.id = obj[i].cn_id;
  //         instance.contact_number.country_code = obj[i].country_code;
  //         instance.contact_number.number = obj[i].number;
  //         instance.contact.first_name = obj[i].first_name;
  //         instance.contact.last_name = obj[i].last_name;
  //         instance.description = obj[i].content;
  //         instance.date = obj[i].date_time;
  //         instance.title = instance.contact.first_name + " " + (obj[i].last_name != null ? obj[i].last_name : "");
  //         instance.isHighlighted = obj[i].is_unread == 1;

  //         this.data.push(instance);
  //       }
  //     },

  //     (errorCustom: any) => {

  //     }
  //   );

  // }

  // private reassignVariablesConversation(dataConv: any) {
  //   let arr;

  //   this.total = dataConv.total;
  //   this.arrCVID = [];

  //   arr = dataConv.data;

  //   for (var i = 0; i < arr.length; i++) {
  //     this.arrCVID.push(arr[i].cv_id);
  //   }

  //   return this.arrCVID;
  // }

}
